import { cn } from "@/shared/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/ui/tooltip";

export function AlphaBadge({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={cn(
            "group fixed bottom-4 left-4 z-50",
            "flex items-center gap-1.5 px-2.5 py-1",
            "rounded-full",
            "bg-background/80 backdrop-blur-sm",
            "border border-primary/30",
            "cursor-help select-none",
            "transition-transform duration-300 ease-out",
            "hover:-translate-y-0.5",
            className
          )}
          style={{
            boxShadow: `
              inset 0 0 12px oklch(0.75 0.15 55 / 0.1),
              0 2px 8px oklch(0.05 0.005 250 / 0.3)
            `,
          }}
        >
          <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inset-0 rounded-full bg-primary opacity-60 transition-transform duration-300 group-hover:scale-150" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary" />
          </span>

          <span
            className="text-[10px] font-mono font-semibold uppercase tracking-widest text-primary transition duration-300"
            style={{ textShadow: "0 0 8px oklch(0.75 0.15 55 / 0.2)" }}
          >
            Alpha
          </span>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" sideOffset={8}>
        <p className="text-center text-xs">
          You're testing an early version.
          <br />
          <span className="opacity-70">Expect rough edges!</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
